import { createStore } from "effector";
import { DegradedModeDTO } from "@state/degraded/dto/response/degraded.mode.dto";
import { degradedContextEvent } from "@state/degraded/DegradedEvent";
import { requestGetDegradedMode } from "@state/degraded/DegradedEffects";

export const degradedStore = createStore<DegradedModeDTO | null>(null)
  .on(degradedContextEvent, (_, payload) => {
    return payload ?? null;
  })
  .on(requestGetDegradedMode.doneData, (_, payload) => payload.data ?? null);
